import React from 'react'

export default function Page404() {
    return (
        <div>
            Page 404
        </div>
    )
}
